import * as React from "react";
import { useState, useCallback } from "react";
import { Button, Icon, AppBar } from "@mui/material";
import { Link } from 'gatsby';
import styled from "styled-components";
import ALEiGNDrawer from "./a-l-ei-g-n-drawer";
import PortalDrawer from "./portal-drawer";

const Continlogo2a1Icon = styled.img`
  width: auto;
  position: relative;
  height: 2.375rem;
  overflow: hidden;
  flex-shrink: 0;
`;
const LogoIcon = styled.img`
  align-self: stretch;
  width: 100px;
  max-height: 100%;
  object-fit: cover;
`;
const Logocontainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;
const LinkOne = styled(Button)`
  position: relative;
`;
const LinkThree = styled(Button)`
  align-self: stretch;
  // width: 4.688rem;
  position: relative;
`;
const NavLinkDropdown = styled(Button)`
  align-self: stretch;
`;
const Navlinks = styled.nav`
  margin: 0;
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: var(--gap-11xl);
  @media screen and (max-width: 960px) {
    display: none;
  }
`;
const HamburgerMenuIcon = styled.img`
  height: 1.5rem;
  width: 1.5rem;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
  @media screen and (max-width: 960px) {
    display: flex;
  }
`;
const NotificationBellIcon = styled.img`
  width: 1.5rem;
  position: relative;
  height: 1.5rem;
  overflow: hidden;
  flex-shrink: 0;
  display: none;
`;
const ProfilePictureIcon = styled.img`
  width: 2.25rem;
  border-radius: var(--br-19xl);
  height: 2.25rem;
  object-fit: cover;
  display: none;
`;
const AccountSection = styled.div`
  width: 2.25rem;
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: var(--gap-xs);
  @media screen and (max-width: 960px) {
    display: flex;
    flex: 1;
  }
  height: ${(p) => p.accountSectionHeight};
`;
const ActionButton = styled(Button)``;
const ActionButton1 = styled(Button)`
  display: none;
`;
const Button1 = styled.div`
  position: relative;
  line-height: 150%;
  text-transform: uppercase;
`;
const IconChevronRight = styled.img`
  width: 1.5rem;
  position: relative;
  height: 1.5rem;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: cover;
`;
const StylelinkSmallfalseDark = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: var(--padding-xs) var(--padding-5xl);
  gap: var(--gap-5xs);
`;
const ActionButtonLink = styled.div`
  display: none;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;
const ActionButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: var(--gap-11xl);
`;
const Container = styled.div`
  align-self: stretch;
  width: 82rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: var(--gap-13xl);
`;
const NavbarRoot = styled.header`
  align-self: stretch;
  background-color: var(--dominant);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: var(--padding-3xl) var(--padding-61xl);
  z-index: 99;
  position: sticky;
  top: 0;
  text-align: left;
  font-size: var(--btns-size);
  color: var(--border-primary);
  font-family: var(--text-tiny-link);
`;

const Navbar = ({
  continLogo2a1,
  accountSection,
  accountSectionHeight,
  hamburgerMenu,
  showHamburgerMenuIcon,
  notificationBell,
  profilePicture,
  actionButton,
  iconChevronRight,
  showActionButton,
  showActionButtonLink,
}) => {
  const [isDrawersOpen, setDrawersOpen] = useState(false);

  const openDrawers = useCallback(() => {
    setDrawersOpen(true);
  }, []);

  const closeDrawers = useCallback(() => {
    setDrawersOpen(false);
  }, []);

  return (
    <>
      <NavbarRoot>
        <Container>
          <Link to='/'>
            <Logocontainer>
              <LogoIcon alt="" src="/logo@2x.png" />
              <Continlogo2a1Icon alt="" src="/continlogo2a-1.svg" />
            </Logocontainer>

          </Link>
          <Navlinks>
            
            {/* <LinkOne
              disableElevation={true}
              color="primary"
              variant="text"

            >
              Solutions
            </LinkOne> */}
            <LinkOne
              disableElevation={true}
              color="primary"
              variant="text"
              href='/e8Guide'
            >
              Resources
            </LinkOne>
            <LinkOne
              disableElevation={true}
              color="primary"
              variant="text"
              target="_blank"
              href='https://www.aleign.com/#AboutV2'
            >
              About Us
            </LinkOne>
            {/* <NavLinkDropdown
              disableElevation={true}
              color="primary"
              variant="text"
              endIcon={<Icon>arrow_forward_ios_sharp</Icon>}
              
            >
              Resources
            </NavLinkDropdown> */}
          </Navlinks>
          {!accountSection && (
            <AccountSection accountSectionHeight={accountSectionHeight}>
              {showHamburgerMenuIcon && (
                <HamburgerMenuIcon
                  alt=""
                  src={hamburgerMenu}
                  onClick={openDrawers}
                />
              )}
              <NotificationBellIcon alt="" src={notificationBell} />
              <ProfilePictureIcon alt="" src={profilePicture} />
            </AccountSection>
          )}
          <ActionButtonGroup>
            <ActionButton
              disableElevation={true}
              color="primary"
              variant="contained"
              onClick={() => window.FreshworksWidget('open')}
            >
              {actionButton}
            </ActionButton>
            {/* <ActionButton1
              disableElevation={true}
              color="primary"
              variant="contained"
              
            >
              Button
            </ActionButton1> */}
            <ActionButtonLink>
              <StylelinkSmallfalseDark>
                <Button1>Sign Up</Button1>
                <IconChevronRight alt="" src={iconChevronRight} />
              </StylelinkSmallfalseDark>
            </ActionButtonLink>
          </ActionButtonGroup>
        </Container>
      </NavbarRoot>
      {isDrawersOpen && (
        <PortalDrawer
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Left"
          onOutsideClick={closeDrawers}
        >
          <ALEiGNDrawer onClose={closeDrawers} />
        </PortalDrawer>
      )}
    </>
  );
};

export default Navbar;
